import PaymentSuccess from "./PaymentSuccess";
import PaymentStatus from "./PaymentStatus";

export const paymentUserRoutes = (data) => [
  // {
  //   path: "/:lang/user/payment/payment-settings",
  //   title: "Payment",
  //   layout: "user",
  //   routeType: "organization",
  //   component: PaymentSettings,
  // },
  {
    path: "/:lang/payment-account/success",
    title: "Payment",
    // routeType: ["user", "organization"].includes(data?.user?.role)? data?.user?.role: "user"
    component: PaymentSuccess,
  },
  {
    path: "/:lang/payment-account/status",
    title: "Payment",
    // routeType: ["user", "organization"].includes(data?.user?.role)? data?.user?.role: "user"
    component: PaymentStatus,
  },
];
